module.exports = __webpack_public_path__ + "img/icon-fecha.52457e1a.svg";